<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em;">The seed for <em>Brotherly Love</em> began with a chat in the car with my eldest son, John, on a trip to Liverpool when he explained the workings of the finance of private schools. The teaching insight came from his brother, Steve, so a real family affair. Thanks guys.</p><br/>
<p style="text-indent:00em;">Special thanks go to my brother, Bill, for his critiques, editing and ongoing support. Also to Robin Styles whose insight and feedback was invaluable to telling the tale of the Solomon brothers. It’s amazing what you can achieve over a couple of beers.</p><br/>
<p style="text-indent:00em;">Cheers, guys, couldn’t have done it without you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1b5abdaa